<template>
  <div class="perfect">
    <div v-if="list.length" class="perfect-header">
      <el-tabs v-model="listIndex">
        <el-tab-pane
          v-for="(item, index) in list"
          :key="item.reservationNo"
          :label="item.reservationNo"
          :name="`${index}`"
        />
      </el-tabs>
    </div>
    <PerfectHeader ref="header" :data="data" :list="list" />
    <el-form :model="data" label-width="auto" @submit.native.prevent.stop>
      <div class="perfect-group">
        <div class="perfect-group-header">
          <div class="perfect-group-title">
            <i class="title-decorate iconfont icon-decorate" />
            {{ $t('formTitle.baseInfo') }}
          </div>
        </div>
        <div class="perfect-group-form">
          <form-list :data="data" :row="{ gutter: 20 }" :options="form1" />
        </div>
      </div>
      <!-- 货物信息 -->
      <div class="perfect-group">
        <div class="perfect-group-form">
          <form-list :data="data" :row="{ gutter: 20 }" :options="form3" />
        </div>
      </div>
      <!-- 送货人信息 -->
      <div class="perfect-group">
        <div class="perfect-group-header">
          <div class="perfect-group-title">
            <i class="title-decorate iconfont icon-decorate" />
            {{ $t('deliveryappointment.urgentreservation.senderInfo') }}
          </div>
        </div>
        <div class="perfect-group-form">
          <form-list :data="data" :row="{ gutter: 20 }" :options="form2" />
        </div>
      </div>
    </el-form>
    <div class="zl-form-buttons">
      <el-button class="zl-form-submit" type="primary" @click="submit">{{ $t('deliveryappointment.urgentreservation.submit') }}</el-button>
      <el-button @click="$router.back()">{{ $t('common.cancel') }}</el-button>
    </div>
  </div>
</template>

<script>
import Form from '@/utils/form'
import Search from '@utils/search'
import TableSelect from '@utils/table-select'
import Table from '@utils/table'
import http from '@/plugin/axios'
import PerfectHeader from './components/perfect-header'
import FormList from '@/utils/form/components/add-page-list.js'
import Operation from '@utils/common/operation'
import MultipleTable from '@utils/multiple-table'

const form1 = new Form('deliveryappointment.urgentreservation')
  .add('vehicleType')
  .add('numberPlate').label('numberPlatep')
  .add('vehicleDescription').label('vehicleDescriptionp')
  // .add('urgentReason').label('urgentReasonp').required()

const form2 = new Form('deliveryappointment.urgentreservation')
  .add('deliveryPerson')
  .add('phone')
  .add('deliveryRemarks')

const search = new Search('deliveryappointment.urgentreservation')
  .showInput(false)
  .add('asnNo')
  // .add('supplierNo').label('supOfficeNo').select('/sysOffice/getSysOfficeByParams', { officeType: '2', useable: '0' })

function remove(row, index) {
  const value = [...this.value]
  value.splice(index, 1)
  this.$emit('input', value)
}

const operation = new Operation()
  .add('release').label('common.remove').handle(remove)

const dialogTable = new Table('deliveryappointment.urgentreservation')
  .sortable(false)
  .add('asnNo')
  .add('deliveryDate').label('expectedArrivalDate')
  .add('supplierNo').label('supOfficeNoLabel')
  .add('supplierName').label('supOfficeName')
  .lib('remarks')

function getData(params) {
  return http({
    url: '/srmAsn/getAppointAsnHeadPage',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: {
      ...params,
      condition: {
        ...params.condition,
        purchaseUnitNo: this.vm.data.purchaseUnitNo
      }
    }
  })
}

async function filter(data, value) {
  const res = await http({
    url: '/srmAsn/getAppointAsnBodyList',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: { asnNoList: data.map(item => item.asnNo) }
  })
  const valueSet = new Set(value.map(i => i.asnNo))
  return res.filter(item => !valueSet.has(item.asnNo))
}

const table = new Table('deliveryappointment.urgentreservation')
  .type('none')
  .sortable(false)
  .add('expectArrivalDate')
  .add('goodsNo')
  .add('goodsName')
  .add('deliveryQty')
  .lib('remarks')

const multipleTable = new MultipleTable('deliveryappointment.urgentreservation')
  .add('asnNo')
  .table(table)
  .listProp('asnBodyList')
  .type('none')

const tableSelect = new TableSelect('deliveryappointment.urgentreservation')
  .type('page')
  .url(getData)
  .title('goodInfo')
  .dialogTitle('chooseAsn')
  .width('70%')
  .search(search)
  .table(multipleTable)
  .dialogTable(dialogTable)
  .filter(filter)
  .operation(operation)

const form3 = new Form('deliveryappointment.urgentreservation')
  .table('deliveryHeadList', tableSelect).listRequired()

function verification(list) {
  const result = []
  list.forEach((data) => {
    let message = ''
    if (!(data.deliveryHeadList && data.deliveryHeadList.length)) {
      message = '请选择送货单！'
    }
    if (data.phone && !(/^1[3456789]\d{9}$/.test(data.phone))) {
      message = '请输入正确手机号码！'
    }
    // if (!data.urgentReason) {
    //   message = '请输入紧急预约原因'
    // }
    if (message) {
      result.push({ message: message, data: data })
    }
  })
  return result
}

export default {
  components: {
    PerfectHeader,
    FormList
  },
  data() {
    return {
      listIndex: '0',
      list: []
    }
  },
  computed: {
    data() {
      return this.list[this.listIndex]
    },
    form1() {
      return form1._group.group
    },
    form2() {
      return form2._group.group
    },
    form3() {
      return form3._group.group
    }
  },
  async created() {
    let list = []
    const appointUuid = this.$route.query.appointUuid
    if (appointUuid) {
      list = await http({
        url: '/srmDeliveryAppoint/getDeliveryAppointInfo',
        baseURL: process.env.VUE_APP_PURCHASE_API,
        data: { appointUuid: appointUuid },
        loading: true
      })
    } else {
      list = await http({
        url: '/srmDeliveryAppoint/getAppointDetailListById',
        baseURL: process.env.VUE_APP_PURCHASE_API,
        data: { id: this.$route.params.appointUuid },
        loading: true
      })
    }
    this.list = list.map(item => ({ ...item, deliveryHeadList: [] }))
    this.$nextTick(() => {
      this.$refs.header.countDown()
    })
  },
  methods: {
    async submit() {
      const result = verification(this.list)
      if (result.length) {
        const message = '单号' + result[0].data.reservationNo + '： ' + result[0].message
        return this.$message({ message: message, type: 'warning' })
      }
      const data = this.list.map(item => {
        const copy = { ...item }
        copy.asnNo = item.deliveryHeadList.map(i => i.asnNo).join(',')
        delete copy.deliveryHeadList
        delete copy.deliveryNos
        return copy
      })
      await http({
        url: '/srmDeliveryAppoint/submitReview',
        baseURL: process.env.VUE_APP_PURCHASE_API,
        data: data,
        loading: true
      })
      this.$router.push({ name: 'Myappointment.Myappointment' })
    }
  }
}
</script>

<style lang="scss">
.perfect {
  &-header {
    background: #fff;
    padding: 0 25px;
  }

  &-group {
    background: #ffffff;
    padding-left: 25px;
    padding-right: 25px;
    padding-top: 18px;
    margin-bottom: 12px;
  }
  &-group-header {
    color: #757575;
    font-size: 13px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 18px;
  }
  &-group-title {
    position: relative;
    margin: 0 -10px;
    display: inline-flex;
    align-items: center;
    .title-decorate {
      transform: scale(.7);
      color: #008EE3;
      margin-right: 2px;
    }
  }
  &-group-form {
    padding: 0 12px;
  }
}
</style>
